module.exports = __webpack_public_path__ + "static/media/C-remove.b32e0c8e.svg";